module.exports = __webpack_public_path__ + "fonts/antykwa-torunska-med-regular.ca1f554e.ttf";